<div class="chart-container">
  <canvas id="credit-line-doughnut">{{ chart }} </canvas>
</div>